// extracted by mini-css-extract-plugin
export default {"select-style-button":"OpenStyleSelectorButton_select-style-button__r9K-d"};